import { useCallback } from 'react';

import { useProjectActions } from 'src/store/project';

export const useHandlers = ({ openMenu, closeMenu }) => {
  const projectActions = useProjectActions();

  const handleControlClick = useCallback(() => {
    openMenu();
  }, [openMenu]);

  const handleMenuClose = useCallback(() => {
    closeMenu();
  }, [closeMenu]);

  const handleSubmitForm = useCallback(
    (formData) => {
      projectActions.setImageOverlayProperties(formData);
      closeMenu();
    },
    [projectActions, closeMenu]
  );

  return {
    handleControlClick,
    handleMenuClose,
    handleSubmitForm,
  };
};
